import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Navigator from './Navigator';
import styles from './styles';

function mapStateToProps(state) {
  const { isLoading, data } = state.dev;
  return {
    isLoading,
    data,
  };
}

const Styled = withStyles(styles)(Navigator);

export default connect(
  mapStateToProps,
)(Styled);
